import React, { Fragment } from "react";
import Fade from "react-reveal/Fade";

function Plastictabs() {
  return (
    <Fragment>
      <div className="container-fluid">
        <div className="row singleprod">
          <Fade down delay={500}>
            <div className="col-sm-3 imgeboxes">
              <img
                src={`${process.env.REACT_APP_URL_ASSETS}Assets/img/singleproduct/SalaamPlasticCardTakaful.jpg`}
              />
              <h4>Plastic Card Takaful</h4>
            </div>
          </Fade>

          <Fade up delay={500}>
            <div
              className="col-sm-12 mylist"
              style={{
                backgroundImage: `url(${`${process.env.REACT_APP_URL_ASSETS}Assets/img/singleproduct/SalaamPlasticCardTakafulCover.jpg`})`,
              }}
            >
              <div className="row">
                <div className="col-sm-4">
                  <p>
                    Covers against debits established due to unauthorized use of
                    plastic cards.{" "}
                  </p>
                </div>
              </div>
            </div>
          </Fade>
        </div>
      </div>
    </Fragment>
  );
}

export default Plastictabs;
